import React, {Fragment, useState} from 'react';

import {Box, Button, Collapse, Stack} from '@mui/material';

import {translations} from 'presentation/translations-new';
import {AlertInfo} from 'presentation/components';
import {StyledTypography} from '../BeneficiaryData/styles';
import {BankAlertProps} from './types';

const {title, part1, part2, part3, readLess, readMore} =
	translations['pt-br'].privateFlow.refund.holderDataPage.bankAlert;

export const BankAlert = ({isRefundFlow, dataTagId}: BankAlertProps) => {
	const [expandedState, setExpandedState] = useState(false);

	const handleExpandClick = () => {
		setExpandedState(prev => !prev);
	};

	return (
		<AlertInfo.Root>
			{isRefundFlow ? <AlertInfo.Title title={title} /> : null}

			<StyledTypography variant="body2">
				{part1.text1}
				<strong>{part1.text2}</strong>
				{part1.text3}
			</StyledTypography>
			<Collapse in={expandedState}>
				<Stack gap={2} mt={2}>
					{expandedState ? (
						<Fragment>
							<StyledTypography variant="body2">
								<strong>{part2.text1}</strong>
								{part2.text2}
							</StyledTypography>
							<StyledTypography variant="body2">
								{part3.text1}
								<strong>{part3.text2}</strong>
								{part3.text3}
							</StyledTypography>
						</Fragment>
					) : null}
				</Stack>
			</Collapse>
			<Box display="flex" justifyContent="flex-end" mt={1}>
				<Button
					size="medium"
					onClick={handleExpandClick}
					variant="text"
					data-tag-id={dataTagId}>
					{expandedState ? `${readLess}` : `${readMore}`}
				</Button>
			</Box>
		</AlertInfo.Root>
	);
};
